import axios from "axios";

const DEFAULT_TIMEOUT = 90000;
const DEFAULT_BASE_URL = window?.config?.baseUrl; // 'https://mbal-api-test.azurewebsites.net';


export interface RequestParams {
    url: string;
    baseURL?: string;
    params?: any;
    headers?: any;
    queryParams?: any;
}

const getHeaders: any = () => {
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
};

export const post = async (requestParams: RequestParams) => {
    console.log('Request post', requestParams);
    const response = await axios.post(requestParams.url, requestParams.params, {
        params: requestParams.queryParams,
        baseURL: requestParams.baseURL || DEFAULT_BASE_URL,
        timeout: DEFAULT_TIMEOUT,
        headers: requestParams.headers || getHeaders(),
    });
    return response;
};
